import MyBread from '../../components/Breadcrumbs'
import React, { Fragment, useEffect, useState, Dispatch, SetStateAction } from 'react'
import MaterialTable from 'material-table'
import { ThemeProvider, createTheme, CircularProgress } from '@mui/material';
import { useModal } from 'react-hooks-use-modal';
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from '../../hooks/use-auth';
import axios from 'axios';
import config from 'config';
import { removeKeyWithValue } from 'utils';
import { Wrapper, PageTitle, CreateNew, ModalStyle, FormLabel, FormInput, FormLabelInputWrapper, ModalTitle, ModalForm, ModalSubmit, LoadingContainer, ModalClose } from 'styles/styles';

interface ParentProps {
  data: ParentDataProps[];
  selectedId: number;
  setSelectedId: Dispatch<SetStateAction<number>>;
  setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface ParentDataProps {
  factory_breaking_id: number
  display_id: string
  start_time: string
  end_time: string
  [key: string]: string | number;
}

const Parent = ({ data, selectedId, setSelectedId, setIsParentDataInsert }: ParentProps) => {
  const auth = useAuth();
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const [modalTitle, setModalTitle] = React.useState('');
  const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
  const { reset, register, handleSubmit, formState: { errors } } = useForm<ParentDataProps>();
  const onSubmit: SubmitHandler<ParentDataProps> = async (submitData: ParentDataProps) => {

    let alertList: any[] = [];
    const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined || submitData[key] === '') {
        alertList.push(key)
      }
    });
    if (alertList.length) {
      let text = '';
      parentArray.forEach(item => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== '') {
        alert(text);
        throw new Error('必須項目が未入力です');
      }
    }
    if (submitData.start_time > submitData.end_time) {
      window.alert("開始時刻は終了時刻より前にしてください");
      throw new Error('開始時刻は終了時刻より前にしてください');
    }
    submitData = removeKeyWithValue(submitData, '');
    const branchData = {
      display_id: submitData.display_id,
      factory_breaking_id: submitData.factory_breaking_id ? submitData.factory_breaking_id.toString() : '',
      start_time: submitData.start_time,
      end_time: submitData.end_time,
    }
    try {
      setIsSubmitDisable(true);
      if (!selectedId) {
        await axios.post(`/v0/factories/${auth.factoryId}/factory-breakings`, branchData, {
          headers: auth.authorizationHeader
        });
        window.alert("登録が完了しました");
      } else {
        await axios.patch(`/v0/factories/${auth.factoryId}/factory-breakings`, branchData, {
          headers: auth.authorizationHeader,
          params: { id: selectedId }
        });
        window.alert("変更が完了しました");
      }
      close();
      setIsParentDataInsert(true);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成
  const parentArray = [{ title: '', field: 'factory_breaking_id' },
  { title: '休憩区分ID', field: 'display_id', default: "break-1", type: 'alphanumeric', required: true },
  { title: '開始時間', field: 'start_time', default: '00:00', type: 'time', required: true },
  { title: '終了時間', field: 'end_time', default: '00:00', type: 'time', required: true },]
  const PAGE_TITLE = "休憩区分"
  const defaultObj: any = {};
  for (const element of parentArray) {
    defaultObj[element.field] = element.default;
  }
  const columnsArray: any = [];
  for (const element of parentArray) {
    if (element.title) {
      columnsArray.push({
        title: element.title,
        field: element.field,
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      })
    }
  }
  const listItems = parentArray.map((element: any, index) => {
    if (element.title) {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput {...register(element.field)}
              {...(element.type && { type: config.inputErrorMessage[element.type].type })}
              {...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
              {...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
              {...(element.type && { title: config.inputErrorMessage[element.type].title })}
              {...(element.required && { required: true })}
              {...(element.disable && { disabled: true })}
              {...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
              {...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
            />
          </FormLabelInputWrapper>
        </Fragment>
      )
    }
  }
  );
  //カラムなど生成ここまで

  const defaultMaterialTheme = createTheme();
  const [pageSize, setPageSize] = React.useState(5);

  //IDから既存の値を呼び出し
  async function setModalValue(factory_breaking_id: number) {
    if (!factory_breaking_id) {
      reset(defaultObj);
      setModalTitle("新規作成")
    } else {
      //データの取得axios
      setSelectedId(factory_breaking_id);
      const result: any = await axios.get(`/v0/factories/${auth.factoryId}/factory-breakings`, {
        headers: auth.authorizationHeader,
        params: { id: factory_breaking_id }
      });
      reset(result.data[0]);
      setModalTitle("編集")
    }
  }

  const createNew = async () => {
    setSelectedId(0);
    await setModalValue(0);
    open();
  }

  return (
    <>
      <CreateNew onClick={createNew}>新規作成</CreateNew>
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={PAGE_TITLE}
          columns={columnsArray}
          data={data}
          actions={[
            {
              icon: 'edit',
              tooltip: '編集する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                try {
                  await setModalValue(rowData.factory_breaking_id);
                  open();
                } catch (error) {
                  console.log(error)
                }
              }
            },
            {
              icon: 'delete',
              tooltip: '削除する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                const result = window.confirm(`${rowData.display_id}を削除しますか？`);
                if (result) {
                  try {
                    await axios.delete(`/v0/factories/${auth.factoryId}/factory-breakings`, {
                      headers: auth.authorizationHeader,
                      params: { id: rowData.factory_breaking_id }
                    });
                    setIsParentDataInsert(true);
                    setSelectedId(0);
                  } catch (error: any) {
                    window.alert(error.response.data.error);
                  }
                }
              }
            }
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: { whiteSpace: 'nowrap' },
            rowStyle: { overflowWrap: 'break-word' }
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onRowClick={(event: any, rowData: any) => {
            event.preventDefault();
          }}
        />
      </ThemeProvider>

      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={close}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  )
}

export default function FactoryBreakings() {
  const auth = useAuth();
  const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
  const [parentData, setParentData] = useState<ParentDataProps[]>([]);
  const [selectedId, setSelectedId] = React.useState(0);

  useEffect(() => {
    try {
      axios.get(`/v0/factories/${auth.factoryId}/factory-breakings`, {
        headers: auth.authorizationHeader
      }).then((res: any) => {
        if (res.data.length) {
          setParentData(res.data);
        } else {
          setParentData([]);
        }
        setIsParentDataInsert(false)
      })
    } catch (err) {
      console.log(err)
    }
  }, [auth, isParentDataInsert]);

  return (
    <>
      <Wrapper>
        <MyBread />
        <PageTitle>休憩区分マスタ</PageTitle>
        <Parent data={parentData} selectedId={selectedId} setSelectedId={setSelectedId} setIsParentDataInsert={setIsParentDataInsert} />
      </Wrapper>
    </>
  )
}